/* Default PDP only. Native selectors and Shopify variant availability remain authoritative. */
(() => {
  const evaluateSelection = ({variant,id,selectedOptions,sizePosition=0,sizeCount=0,chosenSize='',loading=false}) => {
    const needsSize = sizePosition > 0 && sizeCount > 1;
    const selectedSize = selectedOptions[sizePosition - 1];
    if (needsSize && (!chosenSize || selectedSize !== chosenSize)) return {ready:false,reason:'size'};
    if (!variant || String(variant.id) !== String(id)) return {ready:false,reason:'updating'};
    if (selectedOptions.length !== variant.options.length || selectedOptions.some((v,i) => !v || v !== variant.options[i])) return {ready:false,reason:'options'};
    if (!variant.available) return {ready:false,reason:'sold-out'};
    if (loading) return {ready:false,reason:'loading'};
    return {ready:true,reason:'ready'};
  };
  const formatSelection = variant => {
    const parts = String(variant?.title || '').split('/').map(part => part.trim());
    const euIndex = parts.findIndex(part => /^EU\s*\d/i.test(part));
    if (euIndex < 0 || euIndex === parts.length - 1) return variant?.title || '';
    const us = parts[parts.length - 1].replace(/^US\s*/i,'').replace(/\s*-\s*/g,'–');
    return [parts.slice(0,euIndex).join(' / '),parts[euIndex]+' (US '+us+')'].filter(Boolean).join(' · ');
  };
  // The same selection rules are exercised by the local regression tests.
  if (typeof module !== 'undefined' && module.exports) { module.exports={evaluateSelection,formatSelection}; return; }
  const parse = (node,fallback) => { try { return JSON.parse(node?.textContent || 'null') ?? fallback; } catch (_) { return fallback; } };
  const setText = (el,text) => { if (el && el.textContent !== text) el.textContent=text; };
  const normalize = text => String(text || '').replace(/\s+/g,' ').trim();
  const init = () => document.querySelectorAll('[data-sss-pdp-master]').forEach(root => {
    if (root.dataset.sssBound) return;
    root.dataset.sssBound='true';
    const config=parse(root.querySelector('[data-sss-pdp-config]'),{});
    let chosenSize='';
    const initial=config.initialVariant;
    if (config.sizePosition && String(new URLSearchParams(location.search).get('variant')) === String(initial?.id)) chosenSize=initial?.options?.[config.sizePosition-1] || '';
    const picker = () => root.querySelector('variant-radios,variant-selects');
    const controls = () => Array.from(picker()?.querySelectorAll('[data-option-position]') || []).filter(el => el.matches('fieldset,.product-form__controls--dropdown')).sort((a,b)=>Number(a.dataset.optionPosition)-Number(b.dataset.optionPosition));
    const getState = () => {
      const mainForm=root.querySelector('.product__buy_buttons form');
      const mainButton=mainForm?.querySelector('[name="add"]');
      const id=mainForm?.querySelector('[name="id"]')?.value;
      const variants=parse(picker()?.querySelector('[data-all-variants-no-high]'),[]);
      const current=parse(picker()?.querySelector('[data-selected-variant]'),initial);
      const variant=variants.find(v=>String(v.id)===String(id)) || (String(current?.id)===String(id) ? current : null);
      let selectedOptions=controls().map(el => el.querySelector('select')?.value || el.querySelector('input[type="radio"]:checked')?.value || '');
      if (!picker() && !config.sizePosition) selectedOptions=variant?.options || [];
      const loading=!!(mainButton?.classList.contains('loading') || root.querySelector('.product-sticky-add-bar [name="add"]')?.classList.contains('loading') || picker()?.classList.contains('high-variant-loading'));
      const result=evaluateSelection({variant,id,selectedOptions,sizePosition:config.sizePosition,sizeCount:config.sizeCount,chosenSize,loading});
      if (result.reason==='loading' && picker()?.classList.contains('high-variant-loading')) result.reason='updating';
      return {...result,ready:!!mainForm && !!mainButton && result.ready,mainForm,mainButton,id,variant,selectedOptions,loading};
    };
    const messages={size:'Choose a size',options:'Choose your options',updating:'Updating selection…','sold-out':'Sold out',loading:'Adding…',ready:'Add to cart'};
    const recordSizeChoice = target => {
      const sizeControl=controls().find(el=>Number(el.dataset.optionPosition)===Number(config.sizePosition));
      if (!sizeControl) return;
      let input=target.closest('input[type="radio"],select');
      const label=target.closest('label[for]');
      if (!input && label) input=document.getElementById(label.htmlFor);
      if (input && sizeControl.contains(input)) { chosenSize=input.value; return; }
      const swatch=target.closest('.swatch-button,[role="radio"]');
      if (!swatch || swatch.querySelector('img')) return;
      const span=swatch.querySelector('[data-sss-size-raw]') || swatch.querySelector('.swatch-button-title-text');
      const raw=normalize(span?.dataset.sssSizeRaw || span?.textContent);
      const match=Array.from(sizeControl.querySelectorAll('input[type="radio"],option')).find(el=>normalize(el.value)===raw);
      if (match) chosenSize=match.value;
    };
    const compactColors = () => {
      root.querySelectorAll('[role="radiogroup"]').forEach(group=>{
        if (!group.querySelector('img')) return;
        group.classList.add('sss-pdp-color-group');
        const prices=Array.from(group.querySelectorAll('*')).filter(el=>!el.children.length && /^\s*\$\s*[\d,]+\.\d{2}\s*$/.test(el.textContent));
        const repeated=prices.length>1 && new Set(prices.map(el=>el.textContent.replace(/\s/g,''))).size===1;
        prices.forEach(el=>el.classList.toggle('sss-pdp-repeated-price',repeated));
      });
    };
    const chart=root.querySelector('.sss-pdp-chart');
    const chartButton=root.querySelector('[data-sss-chart-open]');
    const chartSlot=root.querySelector('[data-sss-chart-link-slot]');
    if (chart && chartButton && typeof chart.showModal==='function') {
      chart.querySelector('[data-sss-chart-body]').appendChild(root.querySelector('[data-sss-chart-content]'));
      root.classList.add('sss-pdp-enhanced'); chartButton.hidden=false;
      chartButton.addEventListener('click',()=>{ if (!chart.open) chart.showModal(); });
      chart.querySelector('[data-sss-chart-close]').addEventListener('click',()=>chart.close());
      chart.addEventListener('close',()=>chartButton.focus());
      chart.addEventListener('click',event=>{
        if (event.target!==chart) return;
        const r=chart.getBoundingClientRect();
        if (event.clientX<r.left || event.clientX>r.right || event.clientY<r.top || event.clientY>r.bottom) chart.close();
      });
    }
    const placeChartLink = () => {
      if (!chartButton || chartButton.hidden) return;
      const heading=Array.from(root.querySelectorAll('.product-form__group-name,legend,h3,p,span,div')).find(el=>{
        if (el.closest('.sss-pdp-size-help,.sss-pdp-chart,.complete-look') || el===chartButton || el.contains(chartButton)) return false;
        return /^(select a size|size)$/i.test(normalize(el.textContent)) && el.getClientRects().length>0;
      });
      if (heading) { heading.classList.add('sss-pdp-size-heading'); heading.appendChild(chartButton); }
      else if (!chartButton.isConnected && chartSlot) chartSlot.appendChild(chartButton);
    };
    const expressDisclosure = state => {
      const checkout=state.mainForm?.querySelector('.product-form__checkout');
      if (!checkout) return;
      let disclosure=checkout.closest('.sss-pdp-express');
      if (!disclosure) {
        disclosure=document.createElement('details'); disclosure.className='sss-pdp-express';
        const summary=document.createElement('summary'); summary.textContent='Express checkout';
        checkout.before(disclosure); disclosure.append(summary,checkout);
      }
      disclosure.hidden=!state.ready; disclosure.inert=!state.ready;
      if (!state.ready) disclosure.open=false;
    };
    const sync = () => {
      if (!root.isConnected) { observer.disconnect(); return; }
      const state=getState();
      root.classList.toggle('sss-pdp-purchase-locked',!state.ready);
      const main=state.mainButton;
      if (main && !main.classList.contains('loading')) {
        if (main.disabled===state.ready) main.disabled=!state.ready;
        if (main.getAttribute('aria-disabled')!==String(!state.ready)) main.setAttribute('aria-disabled',String(!state.ready));
        setText(main.querySelector('.button__label,.button-wrapper-anim>span,span'),state.ready ? (window.variantStrings?.addToCart || 'Add to cart') : messages[state.reason]);
      }
      const selectedText=state.ready ? (config.sizePosition ? formatSelection({title:state.selectedOptions[config.sizePosition-1]}) : '') : messages[state.reason];
      setText(root.querySelector('[data-sss-pdp-selection]'),selectedText);
      const sticky=root.querySelector('.product-sticky-add-bar');
      if (sticky) {
        const container=sticky.querySelector('.product-sticky-add-bar__container');
        let mobileSummary=sticky.querySelector('.sss-pdp-sticky-mobile-selection');
        if (!mobileSummary && container) {
          mobileSummary=document.createElement('button');
          mobileSummary.type='button';
          mobileSummary.className='sss-pdp-sticky-mobile-selection';
          mobileSummary.setAttribute('aria-label','Review selected color and size');
          container.prepend(mobileSummary);
        }
        const optionNames=Array.isArray(config.optionNames) ? config.optionNames : [];
        const colorIndex=optionNames.findIndex(name=>/colou?r/i.test(String(name)));
        const sizeIndex=config.sizePosition ? config.sizePosition-1 : optionNames.findIndex(name=>/size/i.test(String(name)));
        const colorValue=colorIndex>=0 ? state.selectedOptions[colorIndex] : '';
        const sizeValue=sizeIndex>=0 ? state.selectedOptions[sizeIndex] : '';
        const sizeLabel=sizeValue ? (/^EU\s*/i.test(sizeValue) ? sizeValue : 'EU '+sizeValue) : '';
        const mobileSelectionText=state.ready
          ? [colorValue,sizeLabel].filter(Boolean).join(' · ')
          : colorValue
            ? [colorValue,'Choose size'].join(' · ')
            : 'Select color & size';
        setText(mobileSummary,mobileSelectionText);
        let desktopSummary=sticky.querySelector('.sss-pdp-sticky-desktop-selection');
        if (!desktopSummary && container) {
          desktopSummary=document.createElement('button');
          desktopSummary.type='button';
          desktopSummary.className='sss-pdp-sticky-desktop-selection';
          desktopSummary.setAttribute('aria-label','Review selected color and size');
          const controlsWrap=sticky.querySelector('.product-sticky-add-bar__controls');
          if (controlsWrap) controlsWrap.prepend(desktopSummary); else container.appendChild(desktopSummary);
        }
        setText(desktopSummary,mobileSelectionText);
        const button=sticky.querySelector('[name="add"]');
        const input=sticky.querySelector('[name="id"]');
        if (button && !button.classList.contains('loading')) {
          const stickyLabel = state.ready
            ? (window.variantStrings?.addToCart || 'Add to cart')
            : state.reason === 'sold-out'
              ? 'Choose another size'
              : state.reason === 'size'
                ? 'Choose a size'
                : messages[state.reason];
          button.disabled=!!state.loading;
          button.setAttribute('aria-disabled',String(!!state.loading));
          button.dataset.stickyAction=state.ready ? 'add' : 'select';
          setText(button.querySelector('.button__label,.button-wrapper-anim>span,span'),stickyLabel);
        }
        if (state.ready && input) { if (input.value!==state.id) input.value=state.id; input.disabled=false; }
      }
      expressDisclosure(state); compactColors(); placeChartLink();
    };
    let timer;
    const schedule=()=>{ clearTimeout(timer); timer=setTimeout(sync,40); };
    const observer=new MutationObserver(records=>{
      if (records.some(record=>record.type==='childList' || record.attributeName!=='class' || record.target.matches('variant-radios,variant-selects,.product-form__submit'))) schedule();
    });
    observer.observe(root,{subtree:true,childList:true,attributes:true,attributeFilter:['checked','aria-checked','value','disabled','aria-disabled','class']});
    root.addEventListener('click',event=>{
      if (event.isTrusted) recordSizeChoice(event.target);
      const shipping=event.target.closest('[data-sss-open-shipping]');
      if (shipping) { event.preventDefault(); const details=root.querySelector('[data-sss-shipping-details]'); if (details) { details.open=true; details.scrollIntoView({block:'center',behavior:'smooth'}); details.querySelector('summary').focus(); } }
      schedule(); setTimeout(sync,300);
    },true);
    root.addEventListener('change',event=>{
      if (event.isTrusted) recordSizeChoice(event.target);
      if (picker()?.contains(event.target)) root.classList.add('sss-pdp-purchase-locked');
      schedule();
    },true);
    const scrollToSizeSelector=()=>{
      const sizeControl=controls().find(el=>Number(el.dataset.optionPosition)===Number(config.sizePosition));
      const target=sizeControl || root.querySelector('.sss-pdp-size-help,.product-parameters');
      if (!target) return;
      target.scrollIntoView({block:'center',behavior:'smooth'});
      setTimeout(()=>{
        const focusTarget=target.querySelector('input:not([disabled]),select,button,[role="radio"]');
        if (focusTarget && typeof focusTarget.focus==='function') focusTarget.focus({preventScroll:true});
      },350);
    };
    root.addEventListener('click',event=>{
      const summary=event.target.closest('.sss-pdp-sticky-mobile-selection,.sss-pdp-sticky-desktop-selection');
      if (!summary || !root.contains(summary)) return;
      event.preventDefault();
      const target=picker() || root.querySelector('.product-parameters,.sss-pdp-size-help');
      if (!target) return;
      target.scrollIntoView({block:'center',behavior:'smooth'});
      setTimeout(()=>{
        const focusTarget=target.querySelector('input:not([disabled]),select,button,[role="radio"]');
        if (focusTarget && typeof focusTarget.focus==='function') focusTarget.focus({preventScroll:true});
      },350);
    },true);
    root.addEventListener('click',event=>{
      const stickyButton=event.target.closest('.product-sticky-add-bar [name="add"]');
      if (!stickyButton || !root.contains(stickyButton)) return;
      const state=getState();
      if (state.ready) return;
      event.preventDefault();
      event.stopPropagation();
      sync();
      scrollToSizeSelector();
    },true);
    root.addEventListener('submit',event=>{
      const state=getState();
      const isMain=event.target===state.mainForm;
      const isSticky=!!event.target.closest('.product-sticky-add-bar');
      if (!isMain && !isSticky) return;
      const submittedId=event.target.querySelector('[name="id"]')?.value;
      if (!state.ready || String(submittedId)!==String(state.id)) {
        event.preventDefault(); event.stopImmediatePropagation(); sync();
        scrollToSizeSelector();
      }
    },true);
    // This button has no shoe form or size requirement: it submits only the displayed bag variant.
    root.addEventListener('click',async event=>{
      const button=event.target.closest('[data-sss-bag-add]');
      if (!button || button.disabled) return;
      event.preventDefault();
      const card=button.closest('[data-complete-look-card]');
      if (!card || card.hidden || !/^\d+$/.test(button.dataset.variantId || '')) return;
      const status=button.parentElement.querySelector('[data-sss-bag-status]');
      const label=button.querySelector('span');
      button.disabled=true; button.setAttribute('aria-busy','true'); setText(label,'Adding…'); setText(status,'');
      const cart=document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      let added=false;
      try {
        const formData=new FormData(); formData.append('id',button.dataset.variantId); formData.append('quantity','1');
        if (cart) { formData.append('sections',cart.getSectionsToRender().map(section=>section.id)); formData.append('sections_url',location.pathname); cart.setActiveElement(button); }
        const response=await fetch(window.routes?.cart_add_url || '/cart/add.js',{method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:formData});
        const data=await response.json();
        if (!response.ok || data.status) throw new Error(typeof data.description==='string' ? data.description : 'This handbag could not be added. Please try again.');
        added=true; setText(status,'Handbag added to your bag.');
        if (typeof publish==='function' && typeof PUB_SUB_EVENTS!=='undefined') publish(PUB_SUB_EVENTS.cartUpdate,{source:'sss-pdp-handbag',productVariantId:button.dataset.variantId});
        if (cart) { cart.classList.remove('is-empty'); cart.renderContents(data); }
        else location.assign(window.routes?.cart_url || '/cart');
      } catch (error) {
        setText(status,added ? 'Handbag added. Open your shopping bag to review it.' : (error.message || 'Unable to add this handbag. Please try again.'));
      } finally { button.disabled=false; button.removeAttribute('aria-busy'); setText(label,'Add handbag'); }
    });
    sync(); [250,800,2000].forEach(delay=>setTimeout(sync,delay));
  });
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();

/* SSS sticky purchase visibility Sep 22 */
(function () {
  const initStickyPurchaseVisibility = () => {
    document.querySelectorAll('[data-sss-pdp-master]').forEach(root => {
      if (root.dataset.sssStickyPurchaseBound === 'true') return;
      const sticky = root.querySelector('.product-sticky-add-bar');
      const mainBuy = root.querySelector('.product__buy_buttons');
      if (!sticky || !mainBuy) return;
      root.dataset.sssStickyPurchaseBound = 'true';

      const update = () => {
        const bagOpen =
          document.body.classList.contains('cart-overflow-hidden') ||
          document.body.classList.contains('template-cart') ||
          !!document.querySelector('cart-drawer.active');

        if (bagOpen) {
          sticky.classList.remove('active');
          sticky.setAttribute('aria-hidden', 'true');
          return;
        }

        sticky.removeAttribute('aria-hidden');
        const buyRect = mainBuy.getBoundingClientRect();
        const rootRect = root.getBoundingClientRect();
        const footer = document.querySelector('footer');
        const footerRect = footer ? footer.getBoundingClientRect() : null;
        const buyVisible = buyRect.bottom > 0 && buyRect.top < window.innerHeight;
        const productStillInView = rootRect.bottom > Math.min(window.innerHeight * 0.35, 280);
        const clearOfFooter = !footerRect || footerRect.top > window.innerHeight;
        const mobile = window.matchMedia('(max-width: 989px)').matches;
        const optionsAnchor = root.querySelector('.product-parameters, variant-radios, variant-selects, .sss-pdp-size-help');
        const optionsRect = optionsAnchor ? optionsAnchor.getBoundingClientRect() : null;
        const reachedOptions = optionsRect ? optionsRect.top < window.innerHeight * 0.72 : window.scrollY > 240;
        const shouldShow = mobile
          ? reachedOptions && !buyVisible && productStillInView && clearOfFooter
          : buyRect.bottom < 0 && clearOfFooter;
        sticky.classList.toggle('active', shouldShow);
      };

      update();
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyPurchaseVisibility);
  } else {
    initStickyPurchaseVisibility();
  }
  document.addEventListener('shopify:section:load', initStickyPurchaseVisibility);
})();


/* SSS bag-state observer Sep 24 */
(function () {
  const refreshStickyForBagState = () => {
    const bagOpen =
      document.body.classList.contains('cart-overflow-hidden') ||
      document.body.classList.contains('template-cart') ||
      !!document.querySelector('cart-drawer.active');

    document.querySelectorAll('[data-sss-pdp-master] .product-sticky-add-bar').forEach(sticky => {
      if (bagOpen) {
        sticky.classList.remove('active');
        sticky.setAttribute('aria-hidden', 'true');
      } else {
        sticky.removeAttribute('aria-hidden');
      }
    });
  };

  const start = () => {
    refreshStickyForBagState();
    const observer = new MutationObserver(refreshStickyForBagState);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    const drawer = document.querySelector('cart-drawer');
    if (drawer) observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
